import { action as apiAction } from 'api/Api'
import {
  setName
} from '../redux/dates'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  dateId: number
  name: string
}

const requestRenameCustomDate = (payload: Payload) => async dispatch => {
  const { cardId, dateId, name } = payload

  const optimisticAction = optimisticDispatch(dispatch, setName({
    cardId,
    dateId,
    name
  }))

  try {
    await apiAction('RenameCustomDate', {
      id: dateId,
      name
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestRenameCustomDate
